import { atomWithReset } from 'jotai/utils'

import {
  type Brand,
  type CustomerAttribute,
  type Question,
} from '~/hooks/useSurveyQuery'
import {
  type DataDisplayType,
  type SegmentDisplayType,
  type SortValue,
} from '~/utils'

import {
  type ColumnsDiff,
  type DisplayRowId,
  type SortColumnKey,
} from '../utils'

export const columnCustomerAttributeIdsAtom = atomWithReset<
  CustomerAttribute['id'][]
>([])
export const brandIdsAtom = atomWithReset<Brand['id'][]>([])
export const questionIdsAtom = atomWithReset<Question['question_id'][]>([])
export const customerAttributeIdsAtom = atomWithReset<
  CustomerAttribute['id'][]
>([])
export const dataDisplayTypeAtom = atomWithReset<DataDisplayType>('percentage')
export const segmentDisplayTypeAtom =
  atomWithReset<SegmentDisplayType>('fiveSegs')

export const sortValueAtom = atomWithReset<SortValue<SortColumnKey> | null>(
  null,
)

export const hiddenRowIdsAtom = atomWithReset<DisplayRowId[]>([])

// キーは segmentDisplayType。useKeyedAtomEntry(~/hooks/jotai) 経由で
// コンポーネント側から出し入れするため、型はキー無指定の string にしている。
export const commentBySegmentDisplayTypeAtom = atomWithReset<
  Partial<Record<string, string>>
>({})

export const savedCommentBySegmentDisplayTypeAtom = atomWithReset<
  Partial<Record<string, string>>
>({})

export const columnsDiffsAtom = atomWithReset<ColumnsDiff[]>([])
